import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaIcon from './VaIcon.vue'

export default withConfigTransport(VaIcon)
